import { Address } from '@shared/cms/models/group-dining-request';
import { AddressService, ModalService } from '@core/services';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-address',
  templateUrl: './confirm-address.component.html',
  styleUrls: ['./confirm-address.component.less']
})
export class ConfirmAddressComponent implements OnInit {
  enteredAddress: string;
  actualAddress: string;
  disabled: boolean;
  private finalAddress: Address;
  index: string;

  constructor(private modalService: ModalService, private address: AddressService) { }

  ngOnInit() {
    this.disabled = true;
    this.enteredAddress = this.address.getDisplayAddress(this.address.validatedAddresses.inputAddress);
    this.actualAddress = this.address.getDisplayAddress(this.address.validatedAddresses.standardizedAddress);
    this.hideCloseButton();
  }
  confirmAddress() {
    this.modalService.btnEvent.emit({ type: 'confirmAddress', address: this.finalAddress });
    this.modalService.hideModal();
  }

  setAddress(index: string) {
    this.index = index;
    if (index === 'entered') {
      this.finalAddress = this.address.validatedAddresses.inputAddress;
    } else {
      this.finalAddress = this.address.validatedAddresses.standardizedAddress;
    }
    this.disabled = false;
  }
  private hideCloseButton() {
    const element = <HTMLElement>document.querySelector('#modalHeader');
    if (element) {
      element.style.display = 'none';
    }
  }
}
